import { FComponent } from "Components/f-component";
import { getMobileWatcher } from "Utils/window/mobile-watcher";
import { flattenList } from "@/utils/list/flatten-list";
import { useList } from "@/utils/list/use-list";
import { createComponent } from "@/utils/engine/create-component";
import { elementDispatcher } from "@/utils/dispatch-event";
import "./fc-select-result/single";
import "./fc-select-result/multiple";

function getFields(fields = {}) {
  return {
    value: "id",
    text: "text",
    children: "items",
    ...fields,
  };
}

export class ViewModel extends FComponent {
  constructor(params, element, nodes) {
    super(params, element, nodes);

    this.onChange = params.onChange;

    this.elementDispatcher = elementDispatcher(element);

    element.classList.add("fc-select");
    this.inline = params.inline;
    if (this.inline) element.classList.add("fc-select--inline");

    this.emptyText = "Совпадений не найдено";

    this.dropdownClass = params.dropdownClass;
    this.activeCategories = params.activeCategories;

    this.dropdown = ko.observable(null);
    this.listSearch = ko.observable(null);
    this.fieldSearch = ko.observable(null);

    this.disabled = params.disabled;
    this.readMode = params.readMode;

    this.canRenderList = ko.observable(false);
    this.listRendered = ko.observable(false);

    this.fields = getFields(params.fields);

    this.query = ko.observable("");
    this.debouncedQuery = ko.observable("");

    const updateQuery = _.debounce(() => {
      this.debouncedQuery(this.query());
    }, 500);
    this.query.subscribe(() => updateQuery());
    this.debouncedQuery.subscribe(v => {
      if (this.onSearch) {
        this.onSearch(v);
      }
    });

    this.placeholder = params.placeholder;
    this.showSearch = ko.observable(false);
    this.searchPlaceholder = params.searchPlaceholder;
    this.multiple = params.multiple;
    element.classList.add(
      this.multiple ? "fc-select--multiple" : "fc-select--single"
    );
    this.clearable = params.clearable;
    this.blockSelectedGroup = params.blockSelectedGroup;
    this.canRemoveFromList = this.multiple;
    this.disabledLevel = params.disabledLevel;
    this.checkboxes = ko.toJS(params.checkboxes);
    this.allOptionText = params.allOptionText || "Выбрать все";
    this.allOptionValue = params.allOptionValue || "__all__";
    this.selectionTextLimit = params.selectionTextLimit || 30;
    this.isLimitSelectedText = params.isLimitSelectedText || false;
    this.doneButtonText = params.doneButtonText || "Готово";

    if (this.isLimitSelectedText) {
      element.classList.add("fc-select--limited-selection");
    }

    if (this.checkboxes) {
      element.classList.add("fc-select--checkboxes");
    }

    this.optionsForSearch =
      "optionsForSearch" in params ? params.optionsForSearch : 10;
    this.searchable = ko.pureComputed(() => {
      return (
        !params.onSearch && 
        (
          this.multiple ||
          params.searchable ||
          this.optionsForSearch <= this.options().length
        )
      );
    });
    this.onSearch = params.onSearch;

    // выбранные варианты
    this.value = params.value;

    this.childrenProp = params.childrenProp;
    this.optionTextProp = params.optionTextProp; 
    this.disableFoldersSelect = params.disableFoldersSelect;

    const {
      items,
      dispose: disposeList,
      loading: loadingList,
    } = useList({
      items: params.options,
      handleItems: (items) => {
        if (this.fields) {
          items = items.map((i) => {
            let item = { ...i };
            if (this.fields.value) item.id = i[this.fields.value];
            if (this.fields.text) item.text = i[this.fields.text];
            if (this.fields.children) item.items = i[this.fields.children];
            return item;
          });
        }
        return flattenList(items, this.childrenProp, { disableFoldersSelect: this.disableFoldersSelect, textProp: this.optionTextProp });
      },
    });
    this.options = items;
    this.allOption = {
      id: this.allOptionValue,
      text: this.allOptionText,
      isAllOption: true,
    };
    this.showAllOption = ko.pureComputed(() => {
      return this.multiple && this.checkboxes && !this.query().trim();
    });
    this.filteredListOptions = ko.pureComputed(() => {
      return this.filteredOptions().filter((option) => !this.isAllOption(option));
    });
    this.allOptionDisabled = ko.pureComputed(() => {
      return !this.getSelectableOptionIds().length;
    });

    this.disabledOptions = ko.observableArray([]);

    this.allDisabledOptions = ko.computed(() => {
      const selectOptions = ko.toJS(params.disabledOptions);

      return [
        ...this.disabledOptions(),
        ...(Array.isArray(selectOptions) ? selectOptions : []),
      ];
    });

    this.loading = loadingList;

    // const { list } = useListState(items, {
    //   selected: this.value
    // });
    // // список вариантов (с состояниями)
    // this.list = list;

    this.filteredOptions = ko.computed(() => {
      if (!this.searchable()) {
        return this.getDisplayOptions(this.options());
        // return this.list();
      }
      let q = this.debouncedQuery().trim().toLowerCase();
      if (!q) {
        return this.getDisplayOptions(this.options());
        // return this.list();
      }

      return this.getDisplayOptions(
        this.options().filter((o) => this.filterFn(o, q)),
        q
      );
      // return this.list().filter((o) => this.filterFn(o, q));
    });

    this.value.subscribe((v) => {
      if (this.multiple) {
        if (!v.length) {
          this.disabledOptions([]);
        }
      }
    });

    this.selected = ko.computed(() => {
      let value = this.value();
      if (this.multiple) {
        const selected = this.options().filter((i) => value.find(v => v == i.id));
        return this.checkboxes
          ? selected.map((item) => this.decorateSelectedItem(item))
          : selected;
      }

      return [this.options().find((i) => i.id == value)].filter(Boolean);
      // return this.list().filter((i) => i.selected);
    });

    if ("selected" in params && ko.isObservable(params.selected)) {
      params.selected(this.multiple ? this.selected() : this.selected()[0]);
      this.selected.subscribe((v) => params.selected(this.multiple ? v : v[0]));
    }

    if (this.multiple && this.blockSelectedGroup) {
      const items = this.selected();
      items.forEach((item) => this.blockGroup(item.id));
    }

    this.active = ko.observable(false);
    this.dropdownOpened = ko.observable(false);

    this.dropdownOpened.subscribe((v) => {
      this.emitEvent(v ? "show_dropdown" : "hide_dropdown");
    });
    this.active.subscribe((v) => {
      if (v) {
        if (!this.listRendered()) {
          this.canRenderList(true);
          // setTimeout(() => {
          //   this.canRenderList(true);
          // }, 200);
        }

        setTimeout(() => {
          if (this.listSearch()) this.listSearch().focus();
          if (this.fieldSearch()) this.fieldSearch().focus();
        });
      } else {
        this.showSearch(false);
        this.query("");
      }
    });

    this.showSearch.subscribe((v) => {
      if (v) {
        setTimeout(() => {
          if (this.fieldSearch()) this.fieldSearch().focus();
        });
      }
    });

    this.resultItemComponent = null;

    if (this.slots.result)
      this.resultItemComponent = createComponent(this.slots.result);

    ko.applyBindingsToNode(element, {
      css: {
        "fc-select--active": this.active,
        "fc-select--disabled": this.disabled,
        "fc-select--invalid": params.invalid,
        "fc-select--valid": params.valid,
        "fc-select--read-mode": this.readMode,
      },
    });

    let isMobile = getMobileWatcher();

    this.listView = ko.computed(() => {
      if (!this.multiple) return null;
      if (isMobile() || this.checkboxes) return "checkbox";
      return null;
    });

    this.showPlaceholder = ko.pureComputed(() => {
      if (this.selected().length) return false;
      if (this.multiple) {
        if (this.showSearch()) return false;
      }
      if (!this.inline) return true;
      return true;
    });

    this.popperOptions = {
      placement: this.inline ? "bottom-start" : "bottom-end",
      width: this.inline ? 250 : "equal",
      minWidth: 100,
      arrowPosition: {
        placement: this.inline ? "start" : "end",
        offset: 24,
      },
      flip: true,
      ...(params.popperOptions || {}),
    };

    this.popperMobileView =
      "popperMobileView" in params ? params.popperMobileView : "modal";

    this.onReachEnd = params.onReachEnd;
    this.allSelectedState = ko.pureComputed(() => this.isAllSelected());
    this.allPartiallySelectedState = ko.pureComputed(() =>
      this.isAllPartiallySelected()
    );
    this.dropdownCss = ko.pureComputed(() => {
      const classes = [];
      const externalClass = ko.toJS(this.dropdownClass);

      if (typeof externalClass === "string" && externalClass.trim()) {
        classes.push(externalClass.trim());
      }

      if (this.checkboxes) {
        classes.push("fc-select-dropdown--checkboxes");
      }

      return classes.join(" ");
    });
  }

  getDisplayOptions(options = [], q = "") {
    if (!this.multiple || !this.checkboxes) return options;
    if (q) return options;

    return [this.allOption, ...options];
  }

  isAllOption(option) {
    return option && (option.isAllOption || option.id == this.allOptionValue);
  }

  isSelectableOption(option) {
    if (!option) return false;
    if (this.isAllOption(option)) return false;
    if (option.category) return false;

    if ((this.disabledLevel || this.disabledLevel === 0) && option.level >= this.disabledLevel) {
      return false;
    }

    if (this.allDisabledOptions && ko.isObservable(this.allDisabledOptions)) {
      if (this.allDisabledOptions().includes(option.id)) return false;
    }

    if (ko.isObservable(option.disabled) || ko.isComputed(option.disabled)) {
      return !ko.toJS(option.disabled);
    }

    return !option.disabled;
  }

  getSelectedValues() {
    let value = ko.toJS(this.value);
    if (!this.multiple) return [value];
    if (!Array.isArray(value)) return [];
    return value.filter((v) => v != this.allOptionValue);
  }

  getSelectableOptionIds() {
    return this.options()
      .filter((option) => this.isSelectableOption(option))
      .map((option) => option[this.fields.value]);
  }

  isAllSelected() {
    if (!this.multiple || !this.checkboxes) return false;

    const selectableIds = this.getSelectableOptionIds();
    if (!selectableIds.length) return false;

    const selectedValues = this.getSelectedValues();
    return selectableIds.every((id) =>
      selectedValues.some((value) => value == id)
    );
  }

  isAllPartiallySelected() {
    if (!this.multiple || !this.checkboxes) return false;
    const selectedValues = this.getSelectedValues();
    return selectedValues.length > 0 && !this.isAllSelected();
  }

  decorateSelectedItem(item) {
    if (!item) return item;
    if (!this.isLimitSelectedText) return item;

    const text = item[this.fields.text] || "";
    const limit = this.selectionTextLimit || 30;
    const isTruncated = limit && text.length > limit;
    const truncated = isTruncated ? `${text.slice(0, limit)}…` : text;

    return {
      ...item,
      text: truncated,
      resultText: truncated,
      resultTitle: isTruncated ? text : "",
    };
  }

  getAllOptionsValue() {
    return this.getSelectableOptionIds();
  }

  filterFn(option, q) {
    const field = option.text;
    if (!field) return false;
    let isNameFiltered = field.toLowerCase().includes(q);
    if (isNameFiltered) return true;

    if (option.items && option.items.length) {
      let isOptionsFiltered = option.items.some((opt) => this.filterFn(opt, q));
      if (isOptionsFiltered) return true;
    }

    return false;
  }

  _getValue() {
    return this.multiple ? ko.toJS(this.value) : [ko.toJS(this.value)];
  }

  handleOptions(options) {
    let result = [];

    let flatOption = (option, level, parentDisabled) => {
      let isOptionDisabled = parentDisabled || option.disabled;
      let opt = {
        ...option,
        disabled: ko.observable(isOptionDisabled),
        level,
      };

      result.push(opt);

      if ("items" in option && Array.isArray(option.items)) {
        option.items.map((o) => flatOption(o, level + 1, isOptionDisabled));
      }
    };

    options.forEach((o) => flatOption(o, 0));

    return result;
  }

  getOptionByData(optionData) {
    return this.options().find((option) => {
      return option.id == optionData.id;
    });
  }

  isParent(parentId, childId) {
    let list = this.options();
    let item = list.find((i) => i.id === childId);

    while (item && item.level > 0) {
      if (item.parent === parentId) return true;
      item = list.find((i) => i.id === item.parent);
    }

    return false;
  }

  setValue(newValue) {
    if (this.multiple && Array.isArray(newValue)) {
      newValue = newValue.filter((value) => value != this.allOptionValue);
    }

    if (typeof this.onChange === "function") {
      this.onChange(newValue);
      return;
    }
    this.value(newValue);
  }

  selectOption(option) {
    if (!("id" in option)) return;

    if (this.multiple && this.checkboxes && this.isAllOption(option)) {
      const newValue = this.isAllSelected() ? [] : this.getAllOptionsValue();
      this.setValue(newValue);
      return;
    }

    if (option.disabled) {
      if (this.multiple) this.removeOption(option);
      if (this.listView() !== "checkbox") this.dropdown().hide();
      return;
    }

    let value = this.value();
    let optionValue = option.id;
    let removed = false;

    if (this.multiple) {
      if (value.includes(optionValue)) {
        if (this.canRemoveFromList) {
          value = value.filter((o) => o !== optionValue);
          removed = true;
        } else return;
      } else {
        value.push(optionValue);
      }
    } else {
      if (value == optionValue) return;
      value = optionValue;
    }

    if (removed) {
      this.unblockGroup(option.id);
    } else if (this.multiple && this.blockSelectedGroup) {
      value = value.filter((id) => !this.isParent(option.id, id));
      this.blockGroup(option.id);
    }

    if (this.listView() !== "checkbox") this.dropdown().hide();
    if (this.fieldSearch()) this.fieldSearch().focus();
    this.setValue(value);
  }

  blockGroup(optionId) {
    const option = this.options().find((o) => o.id === optionId);
    if (!option) return;

    const items = option.items;

    if (items && items.length) {
      this.disabledOptions([
        ...this.disabledOptions(),
        ...items.map((i) => i.id),
      ]);
    }
  }

  unblockGroup(optionId) {
    let disabled = this.disabledOptions().filter((id) => {
      return !this.isParent(optionId, id);
    });
    this.disabledOptions(disabled);
  }

  removeOption(option) {
    if (this.multiple && this.checkboxes && this.isAllOption(option)) {
      this.setValue([]);
      return;
    }

    const newValue = this.value().filter((item) => item != option.id);
    this.setValue(newValue);

    if (this.multiple && this.blockSelectedGroup) {
      this.unblockGroup(option.id);
    }

    if (this.listView() !== "checkbox") this.dropdown().hide();
  }

  removeAll() {
    if (this.multiple) {
      this.setValue([]);
    } else this.setValue('');
    if (this.dropdown && this.dropdown() && this.dropdown().hide) {
      this.dropdown().hide();
    }
  }

  toggleList(event) {
    if (ko.toJS(this.disabled)) return;

    if (event.target.closest(".fc-select-result__remove")) return;
    if (event.target.closest(".fc-select-field__remove")) return;

    if (!this.dropdown().isOpen()) this.showSearch(true);
    setTimeout(() => {
      this.dropdown().toggle();
    });
  }

  openList() {
    setTimeout(() => {
      if (this.dropdown().isOpen()) {
        this.dropdown().hide();
      } else {
        this.dropdown().toggle();
      }
    });
  }

  hideList() {
    this.dropdown().hide();
  }
}
